module.exports = __webpack_public_path__ + "static/media/meta.37aab551.png";